<nav class="gw-stepper-manual" aria-label="Stepper">
  <ol class="gw-stepper-list">
    <li
      *ngFor="let step of steps; let i = index"
      class="gw-stepper-item"
      [class.is-done]="getStepState(i) === 'done'"
      [class.is-active]="getStepState(i) === 'active'"
      [class.is-todo]="getStepState(i) === 'todo'"
      [class.is-disabled]="getStepState(i) === 'disabled'"
    >
      <button
        type="button"
        class="gw-stepper-btn"
        [disabled]="isStepDisabled(i)"
        (click)="onSelect(i)"
      >
        <span class="gw-stepper-dot" aria-hidden="true">
          {{ i + 1 }}
        </span>

        <span class="gw-stepper-label">{{ step.label }}</span>
      </button>
    </li>
  </ol>
</nav>
